<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_465')}}</div>
    <div slot="body">
      <a-result status="warning" :title="$t('scope.text_848')" sub-:title="$t('scope.text_849')" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm">{{$t('scope.text_850')}}</a-button>
      <a-button @click="cancelDialog">{{$t('scope.text_851')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'DepositResultDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {}
  },
  methods: {
    async handleConfirm () {
      this.cancelDialog()
      if (this.params.refresh) this.params.refresh()
      const { data: { data = [] } } = await new this.$Manager('billing_payments').list({
        params: {
          id: this.params.id,
        },
      })
      this.$bus.$emit('billAccountPaymentStatus', data[0].status)
    },
  },
}
</script>
